import { Location } from '../../../../api/models'
import { BannerType } from '../../../../components/Banner/Banner'

export type LocationBannerErrorRule = {
  ruleName: string // this is only used for testing purposes
  priority: number
  type: BannerType
  title: string
  body: string
  triggerWhen: {
    meetsCondition: (location: Location) => boolean
  }
}

export const locationBannerErrorRules: LocationBannerErrorRule[] = [
  {
    // this is for when someone is not professionally monitored
    ruleName: 'NOT_PROFESSIONALLY_MONITORED',
    priority: 1,
    type: BannerType.Info,
    title: 'This location does not have an active monitoring plan.',
    body: 'The information on this page is not editable.',
    triggerWhen: {
      meetsCondition: (location: Location) => !location.monitoring?.serviceStatus?.professionalMonitoring?.isEnabled
    }
  }
]

/**
 * This function looks at the location and determines if any banner error messages should be shown based on the rules defined in locationBannerErrorRules.
 * It returns the highest priority banner error message that applies to the location, or undefined if no rules apply.
 * @param location
 */
export function getLocationBannerMessage(location: Location): LocationBannerErrorRule | undefined {
  const errorMessages: LocationBannerErrorRule[] = []

  // loop through the rules and check if the location meets the conditions for each rule
  for (const bannerErrorRule of locationBannerErrorRules) {
    if (bannerErrorRule.triggerWhen.meetsCondition(location)) {
      errorMessages.push(bannerErrorRule)
    }
  }

  // return only the highest priority error message
  errorMessages.sort((a, b) => a.priority - b.priority)
  return errorMessages[0]
}
